import "rsuite/dist/rsuite.css";
import React, { useState, useEffect, useRef } from 'react';
import NavigationBar from '../NavigationBar';
import axios from '../axios';
import { Form, Container, Row, Col, Table, Button } from 'react-bootstrap';
import {renderPagination,renderAdvancedPagination, New_Gate_Pass_Modal} from '../utilities';
import { DateRangePicker } from 'rsuite';
import './manage_orders.css';
import { useNavigate } from 'react-router-dom';
import Image from "react-bootstrap/Image";
import { FaPlus, FaTrash } from 'react-icons/fa';
import { useCallback } from 'react';
import debounce from 'lodash/debounce';


function NewGatePass() {
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [orders, setOrders] = useState([]);
    const [job_number, set_job_number] = useState('');
    const [searchClick, setSearchClick] = useState(false); 
    const [style, set_style] = useState('');
    const [filters, setFilters] = useState({
        teamname: '',
        partyname: '',
        buyername: '',
        itemname: '',
        specification: '',
    });
    const [dateRange, setDateRange] = useState([]);

    const [team_options, set_team_options]=useState([]);
    const [party_options, set_party_options]=useState([]);
    const [buyer_options, set_buyer_options]=useState([]);
    const [item_options, set_item_options]=useState([]);
    const [spec_options, set_spec_options]=useState(['Ply 1','Ply 2','Ply 3','Ply 5','Ply 7','PP']);

    useEffect(() => {
        fetch_dropdown_options();
    }, []);

    const fetch_dropdown_options = async () => {
        try {
            const response1 = await axios.get(`${window.backendUrl}/get_all_teams`);
            const response2 = await axios.get(`${window.backendUrl}/get_all_parties`);
            const response3 = await axios.get(`${window.backendUrl}/get_all_buyers`);
            const response4 = await axios.get(`${window.backendUrl}/get_all_items`);
            // const response5 = await axios.get(`${window.backendUrl}/get_all_specifications'); use after making specifications in Manage Data

            const options1 = response1.data.data.map((team) => team['Name']);
            const options2 = response2.data.data.map((party) => party['PartyName']);
            const options3 = response3.data.data.map((buyer) => buyer['Name']);
            const options4 = response4.data.data.map((item) => item['Name']);
            // const options5 = response.data.map((spec) => spec['Name']); use after making specifications in Manage Data
            set_team_options(options1);
            set_party_options(options2);
            set_buyer_options(options3);
            set_item_options(options4);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFilters((prevFormData) => ({ ...prevFormData, [name]: value }));
        setCurrentPage(1);
    };

    const handleSearch = () => {
        setSearchClick(true);
        setCurrentPage(1);
    };

    const handleDateRangeChange = (value) => {
        if (value && value.length === 2) {
            setDateRange(value);
        } else {
            setDateRange([]);
        }
    };


    const fetchDataWithFilters= (page, filters, dateRange, job_number, style) => { 
        const { teamname, partyname, buyername, itemname, specification} = filters; 
        // const page = currentPage
        const start_date = dateRange[0] ? dateRange[0] : ''
        const end_date = dateRange[1] ? dateRange[1] : ''

        axios.get(`${window.backendUrl}/get_all_challans_for_get_pass`, {
            params: { teamname, partyname, buyername, itemname, specification, page, job_number, style, start_date, end_date}
        })
        .then((response) => {
            console.log(response.data.data);
            setOrders(response.data.data);
            setCurrentPage(response.data.currentPage);
            setTotalPages(response.data.totalPages);
            setSearchClick(false);
        })
        .catch((error) => {
            console.log(error);
        });
    };

    // Define the debounced fetch function
    const debouncedFetchData = useCallback(
        debounce((page, filters, dateRange, job_number, style) => {
            // console.log('Debounced fetch:', { page, filters, dateRange });
            fetchDataWithFilters(page, filters, dateRange, job_number, style);
        }, 300), // Adjust debounce delay
        []
    );

    useEffect(() => {
        // Trigger the debounced function
        debouncedFetchData(currentPage, filters, dateRange, job_number, style);

        // Cleanup to cancel any pending debounced calls
        return () => {
            debouncedFetchData.cancel();
        };
    }, [filters, currentPage, searchClick, dateRange, job_number, style, debouncedFetchData]); // Only trigger when these dependencies change


    const [selectedValues, setSelectedValues] = useState([]);

    const [showModal, setShowModal] = useState(false);

    const handleNewGatePassClick =()=>{
        setShowModal(true)
    }

    const handleCheckboxChange = (event) => {
        const { value, checked } = event.target;
        setSelectedValues(prevValues => {
          if (checked) {
            // Add value to selectedValues if checkbox is checked
            return [...prevValues, value];
          } else {
            // Remove value from selectedValues if checkbox is unchecked
            return prevValues.filter(item => item !== value);
          }
        });
    };

    const handle_new_get_pass_save = (data) => {

        const payload = {
            driver_name : data.driver_name,
            vehicle_no : data.vehicle_no,
            created_date : Math.floor(Date.now() / 1000),
            delivery_challan_ids: selectedValues.join(',') 
        };
        console.log(payload)
        // console.log(payload)

        axios.post(`${window.backendUrl}/add_new_gate_pass`, payload)
            .then(response => {
                setSelectedValues([]);
                console.log('yayay')
                fetchDataWithFilters(currentPage, filters, dateRange, job_number, style);
            })
            .catch(error => {
                console.error('There was an error saving the data!', error);
            }
        );
    };
    return (
    <>
        <NavigationBar />
        <Container fluid>
            <Row style={{ marginTop: '20px',marginBottom:'10px' }}>
                <Col className='d-flex'>
                    <h4>Make New Gate Pass</h4>
                    <Button variant='primary' style={{marginLeft:'40px'}} onClick={handleNewGatePassClick}>
                       <span style={{fontWeight:'bold'}}>+</span> New Gate Pass
                    </Button>
                </Col>
                <Col>
                    <Button style={{backgroundColor:'rgba(0,0,0,0.1)',textDecoration:'none',border:'0px',marginRight:'10px', color:'black'}} onClick={()=>navigate("/manage-gate-pass")}>
                        Manage Gate Pass
                    </Button>
                    <DateRangePicker placeholder="Select Order Date Range" onChange={handleDateRangeChange}/>
                </Col>
                <Col>
                    {renderPagination({ totalPages, currentPage, setCurrentPage })}
                    {renderAdvancedPagination({ totalPages, currentPage, setCurrentPage })}
                </Col>
            </Row>
            <Row style={{ marginTop: '20px',marginBottom:'10px' }}>
                <Form className='d-flex flex-wrap justify-content-around' onSubmit={(e) => { e.preventDefault(); handleSearch(); }}>
                    {/* <Form.Select style={{width:'150px'}} name="teamname" value={filters.teamname} onChange={handleInputChange}>
                        <option value="">All Teams</option>
                        {team_options.map((team, index) => (
                            <option key={index} value={team}>
                            {team}
                            </option>
                        ))}
                    </Form.Select> */}
                    <Form.Select style={{width:'150px'}} name="partyname" value={filters.partyname} onChange={handleInputChange}>
                        <option value="">All Parties</option>
                        {party_options.map((party, index) => (
                            <option key={index} value={party}>
                            {party}
                            </option>
                        ))}
                    </Form.Select>
                    <Form.Select style={{width:'150px'}} name="buyername" value={filters.buyername} onChange={handleInputChange}>
                        <option value="">All Buyers</option>
                        {buyer_options.map((buyer, index) => (
                            <option key={index} value={buyer}>
                            {buyer}
                            </option>
                        ))}
                    </Form.Select>
                    <Form.Select style={{width:'150px'}} name="itemname" value={filters.itemname} onChange={handleInputChange}>
                        <option value="">All Items</option>
                        {item_options.map((item, index) => (
                            <option key={index} value={item}>
                            {item}
                            </option>
                        ))}
                    </Form.Select>
                    <Form.Select  style={{width:'150px'}}> 
                        <option value="">All category</option>
                    </Form.Select>
                    <Form.Select style={{width:'150px'}} name="specification" value={filters.specification} onChange={handleInputChange}>
                        <option value="">All specification</option>
                        {spec_options.map((team, index) => (
                            <option key={index} value={team}>
                            {team}
                            </option>
                        ))}
                    </Form.Select>
                    
                    <Form.Control style={{width:'150px'}} type="text" name="style" value={style} onChange={(e) => { set_style(e.target.value); setCurrentPage(1); }} placeholder='Style/ LPD PO No.' />

                    <div className="search_container" style={{width:'150px'}} >
                        <Form.Control type="text" name="job_number" value={job_number} onChange={(e) => { set_job_number(e.target.value); setCurrentPage(1); }} placeholder='Job No.' />
                        <div onClick={handleSearch}><i className="fa fa-search"></i></div>
                    </div>
                </Form>
            </Row>
            <Row>
                <Col>
                    <Table bordered striped condensed="true" style={{ fontSize: '13px', overflowY: 'auto'  }}>
                        <thead className="cf" style={{ position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1 }}>
                            <tr>
                                <th >ID</th>
                                <th rowspan="2">Challan#</th>
                                <th>Job#</th>
                                <th>Company</th>
                                <th rowspan="2">Items</th>
                                <th rowspan="2">Specif.</th>
                                <th>Measurement</th>
                                <th rowspan="2">Ord.<br/>Qty</th>
                                <th rowspan="2">Prod.<br/>Done</th>
                                <th colspan="2">Delivery Info</th>
                                <th colspan="2">Delivery Balance</th>
                                <th rowspan="2">Remarks</th>
                            </tr>
                            <tr>
                                <th>Date</th>
                                <th>Style#</th>
                                <th>Buyer</th>
                                <th>LxWxH</th>
                                <th>Qty</th>
                                <th>Value</th>
                                <th>Qty</th>
                                <th>Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            {orders.map((order, orderIndex) => {
                                let totalOrderQuantity = 0;
                                let totalPrice = 0;

                                const orderRows = order.items.map((item, itemIndex) => (
                                    item.specifications.map((spec, specIndex) => (
                                        spec.gsms.map((gsm, gsmIndex) => {
                                            totalOrderQuantity += gsm.orderQuantity;
                                            totalPrice += gsm.orderQuantity * parseFloat(gsm.unitPrice);
                                            const rowSpanLength = order.items.reduce((acc, item) => acc + item.specifications.reduce((acc, spec) => acc + spec.gsms.length, 0), 0);

                                            return (
                                                <tr key={`${orderIndex}-${itemIndex}-${specIndex}-${gsmIndex}`}>
                                                    {gsmIndex === 0 && specIndex === 0 && itemIndex === 0 && (
                                                        <>
                                                            <td rowSpan={rowSpanLength}>
                                                                <input type="checkbox" value={order.challanId} onChange={handleCheckboxChange} checked={selectedValues.includes(order.challanId.toString())}  style={{marginRight:'10px'}} />
                                                                {order.serial_no}
                                                                <hr style={{ border: '1px solid black' }}/>
                                                                {new Date(order.deliveryDate * 1000).toLocaleString('en-GB', { timeZone: 'Asia/Dhaka', day: '2-digit', month: '2-digit', year: 'numeric'}).replace(/\//g, '.')}
                                                            </td>
                                                            <td rowSpan={rowSpanLength}>{order.challan_no}</td>
                                                            <td rowSpan={rowSpanLength}>{order.jobNo}<hr style={{ border: '1px solid black' }}/>{order.style}</td>
                                                            <td rowSpan={rowSpanLength}>{order.partyName}<hr style={{ border: '1px solid black' }}/>{order.buyerName}</td>
                                                        </>
                                                    )}
                                                    {gsmIndex === 0 && specIndex === 0 && (
                                                        <>
                                                            <td style={{ verticalAlign: 'middle' }} rowSpan={item.specifications.reduce((acc, spec) => acc + spec.gsms.length, 0)}>{item.itemName}</td>
                                                        </>
                                                    )}
                                                    {gsmIndex === 0 && (
                                                        <td style={{ verticalAlign: 'middle' }} rowSpan={spec.gsms.length}>{spec.specification}</td>
                                                    )}
                                                    <td>{gsm.measurement}</td>
                                                    <td>{gsm.orderQuantity}</td>
                                                    <td >{gsm.finishedQty}</td>
                                                    <td>{gsm.deliveryQty}</td>
                                                    <td>${(gsm.deliveryQty * parseFloat(gsm.unitPrice)).toFixed(2)}</td>
                                                    <td>{gsm.deliveryBalance}</td>
                                                    <td>${(gsm.deliveryBalance * parseFloat(gsm.unitPrice)).toFixed(2)}</td>
                                                    {gsmIndex === 0 && specIndex === 0 && itemIndex === 0 && (
                                                        <>
                                                            <td style={{ verticalAlign: 'middle' }} rowSpan={rowSpanLength}>{order.remarks}</td>
                                                        </>
                                                    )}
                                                </tr>
                                            );
                                        })
                                    ))
                                ));

                                return orderRows;
                            })}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </Container>
        <New_Gate_Pass_Modal show={showModal} setShow={setShowModal} handleSave={handle_new_get_pass_save }/>
    </>
    )
}

export default NewGatePass;